import { sendMessage } from '../sendMessage';
import type { InvokeActionFn } from '../types';
import type { Actions } from './types';

export function invokeAction<TType extends Actions['type'] | (string & {})>(
  context: 'appAction' | 'uniclientAction',
  type: TType,
): InvokeActionFn<Actions, TType> {
  return (async (data?: unknown) => await sendMessage({ type: context, payload: { type, data } })) as InvokeActionFn<
    Actions,
    TType
  >;
}
